export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11519.702af610.jpg";